import React from 'react';
import Toggle from "components/Form/Toggle";
import MultiSelector from "components/Form/MultiSelector";
import {
    InteractionAreaFilter, PositionFilter as PositionFilterSpec,
} from "types/AudienceCriteria";
import {useQuery} from "react-query";
import ngage from "services/ngage";
import IconName from "types/IconName";
import {FormikHelpers} from "formik";
import {Item} from 'components/Form/MultiSelector/MultiSelector';

const interactionAreaFilterTemplate: InteractionAreaFilter = {
    interaction_area_id: 0
}

type PositionFilterProps = {
    formik: FormikHelpers<any>
    groupIndex: number
    filter?: PositionFilterSpec | null
}

function PositionFilter({formik, groupIndex, filter}: PositionFilterProps) {
    const {data: interactionAreas, isLoading: interactionAreasLoading} = useQuery(
        ['interaction-areas.all', {page: 1, per_page: 1000}],
        () => ngage.interactionAreas.filtered({page: 1, per_page: 1000})
    )

    const selectableEvents = interactionAreas?.data.map(area => ({
        id: area.id,
        name: area.name,
        description: area.site?.name,
        icon: IconName.LOCATION_MARKER
    })) || []

    const selectedInteractionAreas = filter?.interaction_areas.map(interactionAreaFilter => interactionAreaFilter.interaction_area_id)

    // Handle toggling this filter on and off
    const handleToggle = (checked: boolean): void => {
        formik.setFieldValue(
          `criteria.groups.${groupIndex}.filters.position`,
          checked ? {interaction_areas: [{...interactionAreaFilterTemplate}]} : undefined
        ).catch(console.error)
     }

    // Handle selection of Interaction Areas
    const handleSelectInteractionAreas = (items?: Array<Item>): void => {
        formik.setFieldValue(
            `criteria.groups.${groupIndex}.filters.position.interaction_areas`,
            items?.map(item => ({interaction_area_id: item.id}))
        ).catch(console.error)
    }

    return (
        <div className="mt-8">
            <div className="flex items-center">
                <Toggle
                    label="Interaction Area"
                    checked={!!filter}
                    onChange={handleToggle}
                    loading={interactionAreasLoading}
                    disabled={interactionAreasLoading}
                />
            </div>

            {filter &&
                <div className="mt-2 pl-14">
                    <MultiSelector
                        isLoading={interactionAreasLoading}
                        items={selectableEvents}
                        selectedIds={selectedInteractionAreas}
                        onChange={handleSelectInteractionAreas}
                        required
                    />
                </div>
            }
        </div>
    );
}

export default PositionFilter;